import React from 'react'
import Icon from 'react-icon-base'

const Careerhistory = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g id="Careerhistory" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Careerhistory" transform="translate(-130.000000, -1150.000000)">
        <rect id="Rectangle" fill="#F1F1F1" x="0" y="8" width="1200" height="3822" />
        <g id="Group" transform="translate(32.000000, 410.000000)">
          <g id="Group-7" transform="translate(0.000000, 397.000000)">
            <rect
              id="Rectangle-Copy"
              stroke="#DDDDDD"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="1135"
              height="739"
              rx="4"
            />
            <g id="Group-15" transform="translate(30.000000, 344.000000)">
              <g id="Group-2" transform="translate(69.000000, 0.000000)">
                <g id="Group-Copy" transform="translate(4.000000, 14.000000)" stroke="#3498DB" strokeLinecap="round">
                  <g id="Group">
                    <line x1="0.5" y1="0.3" x2="0.5" y2="14.7" id="Line-2-Copy-3" />
                  </g>
                </g>
                <path
                  d="M29,9.5 L29,27.1428571 C29,28.1685288 28.1572419,29 27.1176471,29 L-1.11764706,29 C-2.15724188,29 -3,28.1685288 -3,27.1428571 L-3,4.85714286 C-3,3.83147118 -2.15724188,3 -1.11764706,3 L22.4117647,3 L29,9.5 C24.6078431,9.5 22.4117647,9.5 22.4117647,9.5 C22.4117647,9.5 22.4117647,7.64285714 22.4117647,3.92857143"
                  id="Path"
                  stroke="#3498DB"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  transform="translate(13.000000, 16.000000) rotate(90.000000) translate(-13.000000, -16.000000) "
                />
                <circle id="Oval" fill="#3498DB" cx="4.5" cy="13.5" r="1.5" />
                <circle id="Oval-Copy" fill="#3498DB" cx="4.5" cy="22.5" r="1.5" />
                <line
                  x1="8.57692308"
                  y1="12.5"
                  x2="22.4230769"
                  y2="12.5"
                  id="Line-2-Copy-6"
                  stroke="#3498DB"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <line
                  x1="11.5"
                  y1="4.5"
                  x2="22.5"
                  y2="4.5"
                  id="Line-2-Copy-7"
                  stroke="#3498DB"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <line
                  x1="11.5"
                  y1="7.5"
                  x2="22.5"
                  y2="7.5"
                  id="Line-2-Copy-8"
                  stroke="#3498DB"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <line
                  x1="8.57692308"
                  y1="18.5"
                  x2="22.4230769"
                  y2="18.5"
                  id="Line-2-Copy-9"
                  stroke="#3498DB"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <line
                  x1="8.57142857"
                  y1="15.5"
                  x2="15.4285714"
                  y2="15.5"
                  id="Line-2-Copy-10"
                  stroke="#3498DB"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <line
                  x1="8.57142857"
                  y1="22.5"
                  x2="12.5"
                  y2="22.5"
                  id="Line-2-Copy-13"
                  stroke="#3498DB"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <line
                  x1="8.57142857"
                  y1="25.5"
                  x2="16.5"
                  y2="25.5"
                  id="Line-2-Copy-14"
                  stroke="#3498DB"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <g
                  id="Page-1-Copy-2"
                  transform="translate(3.000000, 3.000000)"
                  stroke="#3498DB"
                  strokeLinecap="round"
                  strokeLinejoin="round">
                  <path
                    d="M4.6723982,1.8713931 C4.6723982,0.94416072 3.92047016,0.192232684 2.99323778,0.192232684 C2.0660054,0.192232684 1.31407736,0.94416072 1.31407736,1.8713931 C1.31407736,2.79862549 2.0660054,3.55055352 2.99323778,3.55055352 C3.92047016,3.55055352 4.6723982,2.79862549 4.6723982,1.8713931 Z"
                    id="Stroke-1"
                  />
                  <path
                    d="M5.8688,6.42611574 C5.8688,4.83813373 4.58121979,3.55055352 2.99323778,3.55055352 C1.40525577,3.55055352 0.117675562,4.83813373 0.117675562,6.42611574"
                    id="Stroke-3"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
)

Careerhistory.defaultProps = {
  size: 30
}

export default Careerhistory
